module.exports = __webpack_public_path__ + "static/img/2830_phase_function_Paper_Points.948684c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2830_phase_function_Paper_Points.png
// module id = ZVBj
// module chunks = 0